import { Client as WalletConnectClient } from "./client";
export * from "./constants";
export const Client = WalletConnectClient;
export default WalletConnectClient;
//# sourceMappingURL=index.js.map